import * as React from 'react';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';

import TileStandardContext from '../../context/TileStandardContext';
import TileStandardHeaderDetailsSection from './section/TileStandardHeaderDetailsSection';
import TileStandardHeaderDetailsArtistName from './artist-name/TileStandardHeaderDetailsArtistName';
import TileStandardHeaderDetailsLocations from './locations/TileStandardHeaderDetailsLocations';

import { getInfluencerName, getIsBlockedStatus, getLink } from '../../utils/tile-standard';
import { __t, applyTranslations } from 'utils/language';
import {
  GENDER_LABELS,
  getAgeString,
  getInfluencerLocationsPreview,
  hasDataBeenGathered
} from 'utils/influencers';

import './tile-standard-header-details.scss';

applyTranslations(require('../tile-standard-header.i18n.json'));

const MSG_KEY = 'tile_standard_header';

const TileStandardHeaderDetails = React.memo<{}>((): JSX.Element => {
  const content = React.useContext(TileStandardContext);

  const creator = content?.creator;
  const fullName = creator ? getInfluencerName(creator) : '';
  const artistName = creator?.name || creator?.artistName;
  const hasGender = !isNil(creator?.gender);
  const ageString = getAgeString(creator?.age, creator?.ageRange);
  const locations = getInfluencerLocationsPreview(creator?.locations);
  const agencyDetails = creator?.agencyDetails || null;
  const hasData = creator ? hasDataBeenGathered(creator) : false;
  const isBlocked = getIsBlockedStatus(content?.isFreemium, content?.tileIndex);

  return (
    <div className="tile-standard-header-details">
      {
        content && (
          <React.Fragment>
            {
              artistName && (
                <TileStandardHeaderDetailsArtistName
                  artistName={creator?.name || creator?.artistName || ''}
                  url={creator ? getLink(creator) : '#'}
                  isLightweight={Boolean(creator?.isLightweight)}
                  shaded={!hasData}
                />
              )
            }
            <div className="tile-standard-header-details__info">
              {
                fullName && (
                  <TileStandardHeaderDetailsSection
                    label={__t(`${MSG_KEY}.labels.name`)}
                    value={fullName}
                  />
                )
              }
              {
                ageString && (
                  <TileStandardHeaderDetailsSection
                    label={__t(`${MSG_KEY}.labels.age`)}
                    value={ageString}
                    isBlocked={isBlocked}
                  />
                )
              }
              {
                hasGender && (
                  <TileStandardHeaderDetailsSection
                    label={__t(`${MSG_KEY}.labels.gender`)}
                    value={GENDER_LABELS[creator?.gender || 'N']}
                  />
                )
              }
              {
                !isEmpty(locations) && !isNil(creator?.id) && (
                  <TileStandardHeaderDetailsSection
                    label={__t(`${MSG_KEY}.labels.location`)}
                    value={(
                      <TileStandardHeaderDetailsLocations
                        locations={locations}
                      />
                    )}
                  />
                )
              }
              {
                agencyDetails && (
                  <TileStandardHeaderDetailsSection
                    label={__t(`${MSG_KEY}.labels.agency`)}
                    value={agencyDetails.name}
                    isBlocked={isBlocked}
                  />
                )
              }
            </div>
          </React.Fragment>
        )
      }
    </div>
  );
});

export default TileStandardHeaderDetails;
